import React from 'react'
import { Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { format } from '@e3dc-react/shell/Libs/date'

export interface Props {
  installationId: number
  accessRequestAt: string
  company: string
}

/**
 * Table component to show installation information in access request dialog of owner.
 */
const OwnerAccessRequestDialogTable: React.FC<Props> = ({ installationId, company, accessRequestAt }) => {
  const { t } = useCustomTranslation()

  return (
    <Table sx={{ tableLayout: 'fixed', '& td, & th': { border: 0, p: 0, verticalAlign: 'top' } }}>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography variant="subtitle2">{t('installation.overview.installation')}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="subtitle2">{t('installation.overview.company')}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="subtitle2">{t('installation.overview.accessRequestAt')}</Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>
            <Typography variant="body2">{installationId}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body2">{company}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body2">{format(new Date(accessRequestAt), t('common.format.date-fns-date'))}</Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default OwnerAccessRequestDialogTable
